import LabServiceCollection from "@/collections/LabServiceCollection";
import SubmissionStatusLogModel from "@/models/lab/SubmissionStatusLogModel";

export default class SubmissionStatusLogCollection extends LabServiceCollection {
  model() {
    return SubmissionStatusLogModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    
    return CollectionFilter;
  }

}
